export class ConsultationDraftDeleteRequest {
  userId!: string
  consultationId!: string

  constructor(userId: string, consultationId: string) {
    this.userId = userId
    this.consultationId = consultationId
  }
}
